import { Component } from 'react';
import React from 'react';
import RcColorPicker from 'rc-color-picker';
import { Button } from 'antd';
import 'rc-color-picker/assets/index.css';

export class ColorPicker extends Component<
    {
        onChange?: (value: any) => void;
        value?: any;
        defaultColor?: any;
    },
    never
> {
    originalColor = null;

    reset = () => {
        const {
            onChange,
            row: { type },
        } = this.props as any;

        onChange(type === 'signIn' ? '#f4f4f4' : '#ffffff');
    };

    onChange = (res: { color: any }) => {
        const { onChange } = this.props;
        onChange(res.color);
    };

    render() {
        const {
            value,
            row: { type },
        } = this.props as any;

        if (this.originalColor === null) {
            this.originalColor = value;
        }

        const color = value ? value : type === 'signIn' ? '#f4f4f4' : '#ffffff';

        return (
            <div className={'color-picker'}>
                <RcColorPicker
                    className={'change-color'}
                    color={color}
                    onChange={this.onChange}
                    placement="bottomLeft"
                />
                <Button type={'link'} onClick={this.reset}>
                    重置
                </Button>
            </div>
        );
    }
}
